<p-confirmDialog acceptLabel="Ja" rejectLabel="Nein" key="global"></p-confirmDialog>

<router-outlet></router-outlet>

<ng-container *ngIf="appConfig.getUIInfo$() | async as uiInfo">
  <ng-container *ngIf="router.url !== '/login'">
    <ng-container
      *ngIf="
        !uiInfo.customBackgroundImage || uiInfo.customBackgroundImage === '#background_image#';
        else customBackground
      "
    >
      <!--img src="assets/images/hrs-bg-1.jpg" class="background-image bg-1"-->
      <!--img src="assets/images/hrs-bg-2.png" class="background-image bg-2"-->
      <!--img src="assets/images/background.jpg" class="custom-background-image"-->
    </ng-container>

    <ng-template #customBackground>
      <img [src]="uiInfo.customBackgroundImage" class="custom-background-image" />
    </ng-template>
  </ng-container>
</ng-container>

<jml-lib-reactivate-token-dialog></jml-lib-reactivate-token-dialog>
